export default {
  // Simple state deductors
  uploadByResourceId: (state) => (resourceId) => state.uploadByResourceId[resourceId],
};
